<template>
  <div
    ref="flashcard-view-container"
    class="flashcard-view-container"
  >
    <flashcard
      :answered="answered"
      :answer-ids="answerIds"
      :correct="correct"
      :flashcard="currentFlashcard"
      :raw-answer-data="rawAnswerData"
      :show-rationale="true"
      :terminology="isTerminology"
      @set-answer-ids="setAnswerIds"
      @set-raw-answer-data="setRawAnswerData"
    />
    <flashcard-footer
      :answered="answered"
      :answer-ids="answerIds"
      :correct="correct"
      :flashcard="currentFlashcard"
      :raw-answer-data="rawAnswerData"
      :show-bookmark="true"
      @answer="onAnswered"
      @nextFlashcard="goToNextFlashcard"
    />
  </div>
</template>

<script>
import Flashcard from '@components/flashcards/flashcard';
import FlashcardFooter from '@components/flashcards/footer';

import FlashcardViewMixin from '@/mixins/flashcardViews';
import GlobalMixin from '@/mixins/global';

export default {
  name: 'DeeplinkFlashcardView',
  components: {
    Flashcard, FlashcardFooter,
  },
  mixins: [FlashcardViewMixin, GlobalMixin],
  computed: {
    nextFlashcardRoute() {
      return { name: 'home' };
    },
  },
  created() {
    // TODO: This should not be subject to acl restrictions. The rateLimited param is the only way to bypass it on the api. We need to fix this in the future.
    this.$store.dispatch('flashcards/fetchFlashcards', { ids: [this.$route.params.flashcardId], rateLimited: true });
  },
  mounted() {
    if (this.$route.query.discussionId) {
      this.$watch('currentFlashcard', (newVal, oldVal) => {
        if (oldVal?.id !== newVal?.id) {
          this.restoreStateFromFlashcardState(newVal);
        }
      }, { immediate: true });
      this.answered = true;
    }
  },
  methods: {
    onAnswered() {
      const correct = this.evaluateAnswer(this.currentFlashcard, this.answerIds, this.rawAnswerData);
      this.correct = correct;
      this.answered = true;
    },
    restoreStateFromFlashcardState(flashcard) {
      if (!flashcard) {
        return;
      }

      const stateId = `${flashcard?.id}-category-${flashcard?.categoryIds?.[0]}`;
      const state = this.$store.getters['flashcardStates/flashcardStates'][stateId];
      if (state) {
        this.setAnswerIds(state.answerIds);
        this.setRawAnswerData(state.rawAnswerData);
      }

      this.correct = this.evaluateAnswer(flashcard, this.answerIds, this.rawAnswerData);
    },
  },
};
</script>

<style lang='scss' scoped>
  .flashcard-view-container {
    @include flashcard-view;
  }
</style>
